import { adminTypes } from "app/redux/type/adminTypes";

const initialState = {
  isLoading: false,
  foodList: null,
  foodDetails: null,
  msg: "",
};
export const foodReducer = (state = initialState, action) => {
  switch (action.type) {
    case adminTypes.GET_FOOD_DATA_PENDING:
      return {
        ...state,
        isLoading: action.isLoading,
        msg: "",
      };
    case adminTypes.GET_FOOD_DATA_SUCCESS:
      return {
        ...state,
        isLoading: action.isLoading,
        foodList: action.payload,
        msg: "",
      };
    case adminTypes.GET_FOOD_DATA_FAILED:
      return {
        ...state,
        isLoading: action.isLoading,
        foodList: action.payload,
        msg: action.msg,
      };
    case adminTypes.GET_FOOD_DETAIL_PENDING:
      return {
        ...state,
        isLoading: action.isLoading,
        msg: "",
      };
    case adminTypes.GET_FOOD_DETAIL_SUCCESS:
      return {
        ...state,
        isLoading: action.isLoading,
        foodDetails: action.payload,
        msg: "",
      };
    case adminTypes.GET_FOOD_DETAIL_FAILED:
      return {
        ...state,
        isLoading: action.isLoading,
        foodDetails: action.payload,
        msg: action.msg,
      };
    default:
      return state;
  }
};
